/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authorized_Apps_RevokeInputs */



/**
* | output |
* | --- |
* | "Revoke access" |
*
* @param {Authorized_Apps_RevokeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const authorized_apps_revoke = /** @type {((inputs?: Authorized_Apps_RevokeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authorized_Apps_RevokeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Révoquer l'accès")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revocar el acceso")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Revogar o acesso")
	if (locale === "it") return /** @type {LocalizedString} */ ("Revoca l'accesso")
	return /** @type {LocalizedString} */ ("Revoke access")
});